/* ============================================================
   DAILE MVP — логика тиров (2026-09).

   Что делает:
   1. Выбор тира на PDP: карточки [data-mvp-tier], состояние .is-on,
      пересчёт кнопки покупки, скрытые свойства в форме.
   2. Переключатель 300/500 внутри Mini: [data-mvp-pieces].
   3. Чекбокс клея (Mini): [data-mvp-glue] — в демо-режиме меняет
      только цену на кнопке.
   4. Память выбора между страницами: localStorage 'daile_mvp_tier' —
      блок форматов на главной пишет, PDP читает и предвыбирает.
   5. Глобальное состояние window.DAILE_MVP + событие 'daile-mvp:tier'
      на document — на него подписаны липкие панели.
   6. Reveal-анимации .dmvp-reveal (IntersectionObserver).

   Демо-режим: у товаров пока один вариант, цены тиров приходят из
   data-атрибутов секции. Кнопка покупки проксирует клик на нативную
   ATC-кнопку и подставляет выбранный вариант в форму —
   выбор виден в свойствах позиции корзины, но скрыт от покупателя
   (символ подчёркивания).
   ============================================================ */
(function () {
  'use strict';
  if (window.__daileMvpLoaded) return;
  window.__daileMvpLoaded = true;

  var LS_KEY = 'daile_mvp_tier';

  window.DAILE_MVP = window.DAILE_MVP || {
    tier: null,        /* 'mini' | 'classic' | 'signature' */
    pieces: 300,       /* Mini: 300 | 500 */
    glue: false,       /* Mini: клей-набор (апсейл) */
    priceText: ''
  };

  function readSaved() {
    try { return localStorage.getItem(LS_KEY); } catch (e) { return null; }
  }
  function saveTier(tier) {
    try { localStorage.setItem(LS_KEY, tier); } catch (e) { /* приватный режим — не страшно */ }
  }

  function emit() {
    try {
      document.dispatchEvent(new CustomEvent('daile-mvp:tier', { detail: window.DAILE_MVP }));
    } catch (e) { /* старый браузер — липкая панель просто не обновится */ }
  }

  /* ---------- блок форматов на главной ---------- */

  function initFormats() {
    var root = document.querySelector('[data-mvp-formats]');
    if (!root) return;
    root.querySelectorAll('[data-mvp-tier]').forEach(function (card) {
      card.addEventListener('click', function () {
        saveTier(card.getAttribute('data-mvp-tier'));
        /* переход делает сама ссылка внутри карточки; если кликнули мимо
           ссылки — ведём в каталог программно */
        var link = card.querySelector('a[href]');
        if (link && !link.contains(document.activeElement)) {
          window.location.href = link.href;
        }
      });
    });
  }

  /* ---------- блок тиров на PDP ---------- */

  function money(n) {
    /* ЗАПАСНОЙ путь, когда у корня нет готовой строки цены от daile-money.
       Раньше здесь приклеивался знак евро, и на американском рынке выходило
       «82 €»: число уже в валюте рынка, а знак чужой. Неверная валюта хуже
       пропуска, поэтому теперь молчим и отдаём пустую строку. */
    return '';
  }

  function initPdpTiers() {
    var root = document.querySelector('[data-mvp-pdp-tiers]');
    if (!root) return;

    function attr(name, fallback) { return parseFloat(root.getAttribute(name)) || fallback; }
    /* Три набора (2026-09-15): Mini с переключателем 300/500, Classic, Signature */
    var priceMini = { 300: attr('data-price-mini-300', 40), 500: attr('data-price-mini-500', 50) };
    var priceSet  = { classic: attr('data-price-classic', 70), signature: attr('data-price-signature', 80) };
    /* Готовые строки цен в валюте витрины — их печатает Liquid через daile-money.
       При переключении рынка (SAR, USD…) знак и порядок берутся из Shopify, а не зашиты в скрипте. */
    var moneyText = {
      'mini:300': root.getAttribute('data-money-mini-300'),
      'mini:500': root.getAttribute('data-money-mini-500'),
      classic:    root.getAttribute('data-money-classic'),
      signature:  root.getAttribute('data-money-signature')
    };
    var variantIds = {
      'mini:300': root.getAttribute('data-variant-mini-300'),
      'mini:500': root.getAttribute('data-variant-mini-500'),
      'classic':  root.getAttribute('data-variant-classic'),
      'signature': root.getAttribute('data-variant-signature')
    };
    var setNames = {
      mini: root.getAttribute('data-label-mini') || 'DAILE MINI',
      classic: root.getAttribute('data-label-classic') || 'DAILE CLASSIC',
      signature: root.getAttribute('data-label-signature') || 'DAILE SIGNATURE'
    };
    var setSubs = {
      mini: root.getAttribute('data-sub-mini') || '',
      classic: root.getAttribute('data-sub-classic') || '',
      signature: root.getAttribute('data-sub-signature') || ''
    };
    function safeText(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function piecesOf(tier) { return tier === 'mini' ? window.DAILE_MVP.pieces : 1000; }
    var piecesLabel = root.getAttribute('data-pieces-label') || 'pieces';
    var setShort = {
      mini: root.getAttribute('data-short-mini') || 'MINI',
      classic: root.getAttribute('data-short-classic') || 'CLASSIC',
      signature: root.getAttribute('data-short-signature') || 'SIGNATURE'
    };

    var cards = root.querySelectorAll('[data-mvp-tier]');
    var pdp = root.closest('.daile-pdp') || document;
    var form = pdp.querySelector('form[action*="/cart/add"]');
    var atcLabel = document.querySelector('[data-mvp-atc-label]');
    if (!atcLabel && form) {
      atcLabel = form.querySelector('button[type="submit"] span') ||
                 form.querySelector('button[type="submit"]');
    }

    function currentVariantId() {
      var st = window.DAILE_MVP;
      return variantIds[st.tier === 'mini' ? 'mini:' + st.pieces : st.tier] || null;
    }
    function basePrice(tier) {
      if (tier === 'mini') return priceMini[window.DAILE_MVP.pieces] || priceMini[300];
      return priceSet[tier] || priceSet.signature;
    }
    var gluePrice = attr('data-price-glue', 9);
    var glueVariantId = root.getAttribute('data-glue-variant');
    function currentPrice() {
      var p = basePrice(window.DAILE_MVP.tier);
      if (window.DAILE_MVP.tier === 'mini' && window.DAILE_MVP.glue) p += gluePrice;
      return p;
    }
    function moneyFor(tier, pieces) {
      var key = tier === 'mini' ? 'mini:' + (pieces || window.DAILE_MVP.pieces) : tier;
      return moneyText[key] || money(basePrice(tier));
    }
    /* цена над кнопкой с учётом клея — тоже готовой строкой из Liquid, чтобы формат
       валюты не расходился с остальными ценами на странице */
    function moneyTotal() {
      var st = window.DAILE_MVP;
      if (st.tier === 'mini' && st.glue) {
        return root.getAttribute('data-money-mini-' + st.pieces + '-glue') || money(currentPrice());
      }
      return moneyFor(st.tier, st.pieces);
    }

    /* В корзину должен уйти ВЫБРАННЫЙ вариант: подменяем скрытое поле id формы
       и держим в согласии нативный variant-picker (он нужен быстрой покупке). */
    function syncVariantInput() {
      if (!form) return;
      var st = window.DAILE_MVP;
      var id = currentVariantId();
      var key = st.tier === 'mini' ? 'mini-' + st.pieces : st.tier;
      var available = !!id && root.getAttribute('data-available-' + key) === 'true';
      var withGlue = st.tier === 'mini' && st.glue;
      var glueAvailable = !!glueVariantId && root.getAttribute('data-glue-available') === 'true';
      st.available = available && (!withGlue || glueAvailable);
      st.variantId = id;
      form._daileMvpSelection = {
        variantId: id,
        available: st.available,
        addonVariantId: withGlue && glueAvailable ? glueVariantId : null
      };
      var input = form.querySelector('input[name="id"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden'; input.name = 'id'; form.appendChild(input);
      }
      var nextId = st.available ? String(id) : '';
      var changed = input.value !== nextId || input.disabled === st.available;
      input.value = nextId;
      input.disabled = !st.available;
      var labels = window.DAILE_CART_T || {};
      var unavailable = labels.js_cart_unavailable || 'This set is currently unavailable.';
      var addLabel = labels.js_pdp_add_to_cart || 'Add to cart';
      var buttons = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'));
      document.querySelectorAll('[data-daile-sticky-add]').forEach(function (button) { buttons.push(button); });
      buttons.forEach(function (button) {
        button.disabled = !st.available;
        button.setAttribute('aria-disabled', st.available ? 'false' : 'true');
      });
      if (atcLabel) atcLabel.textContent = st.available ? addLabel : unavailable;
      form.querySelectorAll('.shopify-payment-button').forEach(function (button) {
        button.hidden = !st.available || withGlue;
        button.style.display = !st.available || withGlue ? 'none' : 'block';
      });
      if (changed) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
          try { window.Shopify.PaymentButton.init(); } catch (e) {}
        }
      }
    }

    /* Обводка выбора. Две дуги идут от середины верха (там бейдж) вниз по бокам
       и смыкаются внизу. Геометрию считаем в реальных пикселях карточки: при
       растянутом viewBox скруглениям достаётся разный радиус по осям и углы
       перестают совпадать с border-radius. */
    function sizeTraces() {
      /* Сначала только читаем размеры, потом только пишем в DOM: вперемешку
         это заставляло браузер пересчитывать раскладку на каждую карточку. */
      var box = [];
      cards.forEach(function (c) {
        var svg = c.querySelector('.dmvp-tier__trace');
        if (!svg) { box.push(null); return; }
        /* svg лежит по inset:0, то есть по padding-box карточки — значит и мерить
           надо padding-box (clientWidth/Height), а радиус брать внутренний. */
        var w = c.clientWidth, h = c.clientHeight;
        if (!w || !h) { box.push(null); return; }
        var cs = getComputedStyle(c);
        var bw = parseFloat(cs.borderLeftWidth) || 0;
        var raw = parseFloat(cs.borderTopLeftRadius);
        if (!isFinite(raw)) raw = 10;
        /* радиус не может быть больше половины стороны — иначе дуга выворачивается */
        var r = Math.min(Math.max(0, raw - bw), Math.min(w, h) / 2);
        box.push({ svg: svg, w: w, h: h, r: r });
      });
      box.forEach(function (b) {
        if (!b) return;
        var w = b.w, h = b.h, r = b.r, mid = w / 2;
        b.svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
        var dl = 'M' + mid + ' 0 H' + r + ' A' + r + ' ' + r + ' 0 0 0 0 ' + r +
          ' V' + (h - r) + ' A' + r + ' ' + r + ' 0 0 0 ' + r + ' ' + h + ' H' + mid;
        var dr = 'M' + mid + ' 0 H' + (w - r) + ' A' + r + ' ' + r + ' 0 0 1 ' + w + ' ' + r +
          ' V' + (h - r) + ' A' + r + ' ' + r + ' 0 0 1 ' + (w - r) + ' ' + h + ' H' + mid;
        b.svg.querySelectorAll('.dmvp-tier__trace-l').forEach(function (el) { el.setAttribute('d', dl); });
        b.svg.querySelectorAll('.dmvp-tier__trace-r').forEach(function (el) { el.setAttribute('d', dr); });
        /* пока размеров нет, дуги скрыты стилем — теперь их можно показывать */
        b.svg.setAttribute('data-sized', '');
      });
    }
    sizeTraces();
    if (window.ResizeObserver) { new ResizeObserver(sizeTraces).observe(root); }
    else { window.addEventListener('resize', sizeTraces); }

    /* Обводка карточки рисуется, только когда эту карточку видно целиком.
       Следим за каждой отдельно: блок из трёх карточек на телефоне выше экрана,
       и по нему «видно целиком» наступало задолго до самой карточки.
       Класс is-seen ставится один раз и больше не снимается. */
    function markSeen(card) {
      if (card && !card.classList.contains('is-seen')) card.classList.add('is-seen');
    }
    (function watchCards() {
      /* клик по карточке = человек её точно видит */
      cards.forEach(function (c) {
        c.addEventListener('click', function () { markSeen(c); }, true);
      });
      if (!window.IntersectionObserver) { cards.forEach(markSeen); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var vh = window.innerHeight || 0;
          /* «видно целиком» = либо карточка помещается в экран и видна вся,
             либо она выше экрана и занимает почти весь экран */
          var need = Math.min(en.boundingClientRect.height, vh * 0.85);
          if (en.intersectionRect.height >= need - 1) {
            markSeen(en.target);
            io.unobserve(en.target);
          }
        });
      }, { threshold: [0, 0.25, 0.5, 0.75, 0.9, 1] });
      cards.forEach(function (c) { io.observe(c); });
    })();

    function render() {
      var st = window.DAILE_MVP;
      /* Страховка от несуществующего сочетания: у Mini бывает только 300 и 500.
         Если в состоянии оказалось что-то другое, возвращаемся к 300, иначе
         ломаются и цена, и выбор варианта, и фильтр галереи. */
      if (st.tier === 'mini' && !priceMini[st.pieces]) st.pieces = 300;
      cards.forEach(function (c) {
        var on = c.getAttribute('data-mvp-tier') === st.tier;
        c.classList.toggle('is-on', on);
        /* когда набор меняют не кликом по карточке (например кнопкой 300/500),
           переключатель надо синхронизировать вручную */
        var radio = c.querySelector('.dmvp-tier__radio');
        if (radio && radio.checked !== on) radio.checked = on;
      });
      root.querySelectorAll('[data-mvp-pieces]').forEach(function (b) {
        /* капсула горит, только когда выбран сам набор Mini */
        b.classList.toggle('is-on', st.tier === 'mini' && parseInt(b.getAttribute('data-mvp-pieces'), 10) === st.pieces);
      });
      /* неизменяемая капсула «1000» у Classic и Signature темнеет вместе со своей карточкой */
      root.querySelectorAll('.dmvp-pieces__btn.is-static').forEach(function (b) {
        var card = b.closest('[data-mvp-tier]');
        b.classList.toggle('is-on', !!card && card.getAttribute('data-mvp-tier') === st.tier);
      });
      /* цена и характеристики Mini следуют за переключателем 300/500 */
      var miniPrice = root.querySelector('[data-mvp-tier="mini"] [data-mvp-price]');
      if (miniPrice) miniPrice.textContent = moneyFor('mini', st.pieces);
      var sizeEl = root.querySelector('[data-mvp-size]');
      if (sizeEl) sizeEl.textContent = sizeEl.getAttribute('data-size-' + st.pieces) || sizeEl.textContent;
      var timeEl = root.querySelector('[data-mvp-time]');
      if (timeEl) timeEl.textContent = timeEl.getAttribute('data-time-' + st.pieces) || timeEl.textContent;

      st.priceText = moneyTotal();
      /* Над кнопкой: цена крупно и подпись набора. Текст самой кнопки не трогаем —
         там остаётся штатное «Add to cart» темы. */
      var headPrice = document.querySelector('[data-mvp-atc-price]');
      if (headPrice) headPrice.textContent = st.priceText;
      var headSub = document.querySelector('[data-mvp-atc-sub]');
      if (headSub) {
        /* Этикетка над ценой, как подпись под работой в музее: слева фирменная
           связка DAILE + набор, волосяная линия во всю оставшуюся ширину,
           справа число деталей. Цена внизу остаётся единственной крупной. */
        /* у Mini клей — выбор покупателя, поэтому подписываем его состояние;
           у Classic и Signature клей входит всегда, приписка была бы шумом */
        var glueNote = '';
        if (st.tier === 'mini') {
          var gTxt = st.glue ? root.getAttribute('data-glue-with') : root.getAttribute('data-glue-without');
          if (gTxt) glueNote = '<span class="dmvp-atc-head__glue">' + safeText(gTxt) + '</span>';
        }
        headSub.innerHTML = 'DAILE <em>' + safeText(setShort[st.tier]) + '</em> <span class="dmvp-atc-head__sep">|</span> ' +
                            '<b class="dmvp-num">' + piecesOf(st.tier) + '</b><span class="dmvp-atc-head__unit">' + safeText(piecesLabel) + '</span>' +
                            glueNote;
      }

      /* мобильная липкая панель: «DAILE MINI | 300 PIECES» над ценой */
      document.querySelectorAll('[data-mvp-sticky-sub]').forEach(function (el) {
        el.hidden = false;
        /* две части, чтобы на узком экране строка ломалась только у разделителя */
        el.innerHTML = '<span>' + safeText(setShort[st.tier]) + '</span> <span class="daile-sticky__sub-pieces">| ' + piecesOf(st.tier) + ' ' + safeText(piecesLabel) + '</span>';
      });
      /* десктопная липкая панель: в самом названии часть после « | » заменяем подписью набора —
         «“The Kiss” — DAILE x Gustav Klimt | 300 · The Compact Art Puzzle Gift Set» */
      document.querySelectorAll('[data-mvp-sticky-name]').forEach(function (el) {
        if (!el.dataset.base) el.dataset.base = el.textContent.split('|')[0].trim();
        /* «… | 1000 pieces Complete Art Puzzle Set» — цифра Hanken 450, подпись набора без «The» */
        el.innerHTML = safeText(el.dataset.base) + ' | <b class="dmvp-num">' + piecesOf(st.tier) + '</b> ' + safeText(piecesLabel) + ' ' + safeText(setSubs[st.tier]);
      });

      syncVariantInput();
      emit();
    }

    /* Выбор набора теперь делает сам радиопереключатель: клик по карточке
       попадает в подпись-перекрытие, клавиатура работает штатными стрелками.
       Нам остаётся только слушать смену. */
    cards.forEach(function (card) {
      var radio = card.querySelector('.dmvp-tier__radio');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        window.DAILE_MVP.tier = card.getAttribute('data-mvp-tier');
        render();
      });
    });

    root.querySelectorAll('[data-mvp-pieces]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        window.DAILE_MVP.pieces = parseInt(b.getAttribute('data-mvp-pieces'), 10) || 300;
        window.DAILE_MVP.tier = 'mini';
        saveTier('mini');
        render();
      });
    });

    var glue = root.querySelector('[data-mvp-glue] input');
    if (glue) {
      glue.addEventListener('change', function () {
        window.DAILE_MVP.glue = glue.checked;
        window.DAILE_MVP.tier = 'mini';
        render();
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        syncVariantInput();
        if (!window.DAILE_MVP.available) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }

    /* ---------- стартовое состояние ----------
       По умолчанию страница открывается на Mini 300: память прошлого выбора
       убрана намеренно, покупатель ждёт одинаковый стартовый экран, а не
       вчерашний свой клик.

       Исключение — переход по ссылке, которая набор уже назвала. Тогда
       открываем именно его. Понимаем два вида ссылок:
         ?variant=<id>  — родной параметр Shopify, приходит из каталога и из
                          писем; сверяем со списком data-variant-* на корне;
         ?set=classic   — человекочитаемый псевдоним (mini300 | mini-300 |
                          300 | mini500 | classic | signature) на случай
                          ссылок, которые пишутся руками.
       Ничего не найдено или значение чужое — молча остаёмся на Mini 300. */
    function startFromUrl() {
      var q;
      try { q = new URLSearchParams(window.location.search); }
      catch (e) { return null; }

      var variant = q.get('variant');
      if (variant) {
        for (var key in variantIds) {
          if (variantIds[key] && String(variantIds[key]) === String(variant)) {
            return key;
          }
        }
      }

      var alias = (q.get('set') || '').toLowerCase().replace(/[\s_-]/g, '');
      var map = {
        mini300: 'mini:300', '300': 'mini:300',
        mini500: 'mini:500', '500': 'mini:500',
        classic: 'classic',  '1000': 'classic',
        signature: 'signature'
      };
      return map[alias] || null;
    }

    var startKey = startFromUrl();
    if (startKey === 'mini:500') {
      window.DAILE_MVP.tier = 'mini';
      window.DAILE_MVP.pieces = 500;
    } else if (startKey === 'classic' || startKey === 'signature') {
      /* pieces НЕ трогаем. У Classic и Signature число деталей всегда 1000 и
         берётся из самого набора, а записанная сюда 1000 оставалась в состоянии
         после переключения на Mini: получалось несуществующее сочетание
         mini + 1000, при котором цена печаталась запасным путём в евро, а в
         корзину уходил вариант Classic. */
      window.DAILE_MVP.tier = startKey;
    } else {
      window.DAILE_MVP.tier = 'mini';
      window.DAILE_MVP.pieces = 300;
    }
    render();
  }

  /* ---------- галерея по выбранному набору ----------
     Разметку даёт snippets/product-gallery.liquid (mvp_tier_gallery: true):
     слайды/миниатюры/точки помечены [data-mvp-tier-media]:
       "mini" | "classic" | "signature" — фото наборов (метка #set: в alt),
       "legacy" — прежние фото товара (показываются, если фото набора нет).
     Главное фото картины без пометки — видно всегда. */
  function initTierGallery() {
    var gallery = document.querySelector('product-gallery');
    if (!gallery || !gallery.querySelector('[data-mvp-tier-media]')) return;
    var carousel = gallery.querySelector('scroll-carousel');
    var lastKey = null;   /* какой набор показан сейчас; null — ещё ни одного */

    /* Метки в alt: #set:mini | classic | signature, плюс уточнённые
       #set:mini-300 и #set:mini-500 — у Mini первое фото после картины своё
       для 300 и для 500 деталей. Кадр показываем, если он помечен ЛЮБЫМ из
       подходящих ключей. */
    function keysFor(st) {
      var tier = (st && st.tier) ? st.tier : 'mini';
      var keys = [tier];
      if (tier === 'mini' && st && st.pieces) keys.push('mini-' + st.pieces);
      return keys;
    }

    function apply(st) {
      var keys = keysFor(st);
      var key = keys[0];
      /* в метке может быть несколько наборов через запятую: "classic,signature" */
      gallery.querySelectorAll('[data-mvp-tier-media]').forEach(function (el) {
        var list = (el.getAttribute('data-mvp-tier-media') || '').split(',');
        var show = false;
        for (var i = 0; i < list.length && !show; i++) {
          var tag = list[i].trim();
          for (var k = 0; k < keys.length; k++) {
            if (tag === keys[k]) { show = true; break; }
          }
        }
        el.hidden = !show;
      });
      /* Кадры переключаем родным API карусели Prestige: carousel.cells отдаёт
         только видимые кадры, select(i) доводит ленту до нужного. Раньше здесь
         стоял scrollIntoView — он тянул за собой и страницу, отсюда прыжок
         наверх при смене набора. */
      if (!carousel) return;
      var firstRun = (lastKey === null);
      var changed = (!firstRun && key !== lastKey);
      lastKey = key;
      if (firstRun) {
        carousel.select(0, { instant: true });
        /* На телефоне при первом открытии показываем набор одним кругом:
           от картины по кадрам и обратно к картине. Старт — только когда
           страница догрузилась (событие шлёт initPdpTiers). На компе галерея
           и так перед глазами, там стартуем спокойно, без движения. */
        /* один круг через 3 секунды после захода — не ждём, пока человек
           долистает до наборов, фото он видит сразу */
        if (isNarrow() && !noMotion()) { autoRun(0, STEP_DELAY); }
        return;
      }
      /* Переключение 300/500 внутри Mini меняет только первый кадр (mini-300 →
         mini-500). Фильтр выше уже переставил видимость; страницу и
         автопрокрутку при этом не дёргаем — набор тот же. */
      if (!changed) return;
      autoStop();
      var startAt = carousel.cells.length > 1 ? 1 : 0;   /* с первого кадра набора, не с картины */
      if (noMotion()) { carousel.select(startAt); return; }
      /* Сначала на карточке смыкается обводка, и только под конец этого
         движения страница начинает подтягиваться к фото и лента едет дальше. */
      setTimeout(function () {
        bringGalleryIntoView();
        glideTo(startAt);
        autoRun(startAt, STEP_DELAY, true);
      }, TRACE_LEAD);
    }

    /* ——— автопрокрутка галереи ———
       Один круг: от стартового кадра по порядку до последнего, затем возврат
       на картину — и стоп. Любое касание, свайп, колесо или клик по миниатюре
       выключают её сразу. */
    var STEP_DELAY = 3000;    /* пауза между кадрами */
    var PAGE_GLIDE = 1200;    /* сколько едет сама страница к галерее */
    var TRACE_LEAD = 1300;    /* обводка рисуется 1.65с — трогаемся ближе к концу */
    var autoTimer = null;
    var pageRaf = 0;
    var pageFallback = 0;

    function noMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    function isNarrow() {
      return !!(window.matchMedia && window.matchMedia('(max-width: 999px)').matches);
    }
    function easeInOut(p) {
      return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
    }
    function now() {
      return (window.performance && performance.now) ? performance.now() : new Date().getTime();
    }

    /* Плавный переход к кадру. Родной select() уезжает нативным smooth-скроллом
       — он короткий и резкий, длительность не задать. Поэтому: instant-select
       обновляет состояние карусели и миниатюры, позицию отматываем назад и
       ведём своей анимацией с мягкой кривой. */
    /* Переход к кадру делает сама тема: select() уезжает нативным плавным
       скроллом. Свой tween пробовали — он ломал ощущение свайпа и заставлял
       рамку миниатюры прыгать (тема пересчитывает кадр по событию scroll,
       а tween шлёт их каждый кадр). */
    function glideTo(i) {
      if (!carousel) return;
      carousel.select(i, { instant: noMotion() });
    }
    function glideStop() {
      pageStop();
    }

    function autoStop() {
      if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
    }
    function autoRun(startAt, firstDelay, alreadyThere) {
      autoStop();
      if (!carousel || noMotion()) return;
      if (carousel.cells.length < 2) return;
      var i = startAt;
      if (!alreadyThere) glideTo(i);
      autoTimer = setTimeout(function step() {
        autoTimer = null;
        if (i >= carousel.cells.length - 1) {
          glideTo(0);   /* круг замкнулся на картине — дальше не крутим */
          return;
        }
        i += 1;
        glideTo(i);
        autoTimer = setTimeout(step, STEP_DELAY);
      }, firstDelay || STEP_DELAY);
    }

    /* Подтянуть галерею к глазам — своей анимацией, а не нативным smooth:
       нужен заметно более долгий и мягкий ход. */
    function glidePageTo(targetY) {
      var from = window.pageYOffset || document.documentElement.scrollTop || 0;
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      var to = Math.max(0, Math.min(targetY, max));
      if (Math.abs(to - from) < 4) return;
      if (noMotion()) { window.scrollTo(0, to); return; }
      pageStop();
      var t0 = now();
      pageRaf = requestAnimationFrame(function frame() {
        var p = (now() - t0) / PAGE_GLIDE;
        if (p >= 1) { pageStop(); window.scrollTo(0, to); return; }
        window.scrollTo(0, from + (to - from) * easeInOut(p));
        pageRaf = requestAnimationFrame(frame);
      });
      /* та же страховка, что и у ленты: во вкладке на фоне rAF не тикает */
      pageFallback = setTimeout(function () { pageStop(); window.scrollTo(0, to); }, PAGE_GLIDE + 600);
    }
    function pageStop() {
      if (pageRaf) { cancelAnimationFrame(pageRaf); pageRaf = 0; }
      if (pageFallback) { clearTimeout(pageFallback); pageFallback = 0; }
    }
    function bringGalleryIntoView() {
      var r = gallery.getBoundingClientRect();
      var vh = window.innerHeight || 0;
      var visible = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      if (r.height && visible / r.height > 0.6) return;   /* и так видно */
      /* учитываем только реально липкую шапку, иначе фото уедет под неё */
      var pad = 12;
      var head = document.querySelector('#shopify-section-header') || document.querySelector('header');
      if (head) {
        var hp = getComputedStyle(head).position;
        if ((hp === 'sticky' || hp === 'fixed') && head.offsetHeight) pad += head.offsetHeight;
      }
      glidePageTo((window.pageYOffset || 0) + r.top - pad);
    }

    function userTook() { autoStop(); glideStop(); }
    if (carousel) {
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
        carousel.addEventListener(ev, userTook, { passive: true });
      });
      gallery.querySelectorAll('.product-gallery__thumbnail').forEach(function (b) {
        b.addEventListener('click', userTook);
      });
      /* свайп или колесо по самой странице тоже отменяют ведение страницы */
      ['wheel', 'touchstart'].forEach(function (ev) {
        window.addEventListener(ev, pageStop, { passive: true });
      });
    }

    document.addEventListener('daile-mvp:tier', function (e) { apply(e.detail); });
    if (window.DAILE_MVP && window.DAILE_MVP.tier) apply(window.DAILE_MVP);
  }

  /* ---------- «что внутри»: переключение тиров ---------- */

  function initWhatsInside() {
    document.querySelectorAll('[data-mvp-wi]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-mvp-wi-tab]');
      var panes = root.querySelectorAll('[data-mvp-wi-pane]');
      function show(key) {
        tabs.forEach(function (t) {
          t.classList.toggle('is-on', t.getAttribute('data-mvp-wi-tab') === key);
        });
        panes.forEach(function (p) {
          p.classList.toggle('is-on', p.getAttribute('data-mvp-wi-pane') === key);
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-mvp-wi-tab')); });
      });
      /* по умолчанию — выбранный тир, если он есть */
      var start = (window.DAILE_MVP && window.DAILE_MVP.tier) || 'signature';
      if (!root.querySelector('[data-mvp-wi-tab="' + start + '"]')) start = 'signature';
      show(start);
      document.addEventListener('daile-mvp:tier', function (e) {
        if (e.detail && e.detail.tier) show(e.detail.tier);
      });
    });
  }

  /* ---------- липкие панели: показываем выбранный тир ---------- */

  function initStickySync() {
    var targets = document.querySelectorAll('[data-mvp-sticky-price]');
    if (!targets.length) return;
    function apply(st) {
      if (!st || !st.priceText) return;
      targets.forEach(function (el) { el.textContent = st.priceText; });
    }
    document.addEventListener('daile-mvp:tier', function (e) { apply(e.detail); });
    /* Первый выбор тира случается ДО этой подписки (initPdpTiers идёт раньше
       по порядку init) — применяем текущее состояние сразу, иначе в капсуле
       остаётся нативная цена варианта до первого клика. */
    apply(window.DAILE_MVP);
  }

  /* ---------- reveal ---------- */

  function initReveal() {
    var els = document.querySelectorAll('.dmvp-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }


  /* ---------- подарок к дате (PDP) ---------- */

  /* ---------- «не готов сегодня — напомним» ----------
     Почта уходит в Klaviyo клиентским API (публичный company_id, он и так
     в коде каждой страницы). Подписка идёт в отдельный список напоминаний —
     это и есть согласие на одно письмо; рассылка отдельной галочкой.
     Само письмо шлёт сценарий Klaviyo по дате-свойству reminder_due. */

  function initRemind() {
    var root = document.querySelector('[data-mvp-remind]');
    if (!root) return;

    var company = root.getAttribute('data-kl-company');
    var listId = root.getAttribute('data-kl-list');
    var toggle = root.querySelector('[data-mvp-remind-toggle]');
    var emailEl = root.querySelector('[data-mvp-remind-email]');
    var newsEl = root.querySelector('[data-mvp-remind-news]');
    var saveEl = root.querySelector('[data-mvp-remind-save]');
    var msgEl = root.querySelector('[data-mvp-remind-msg]');
    var chips = root.querySelectorAll('[data-mvp-remind-in]');
    var days = 7;

    if (toggle) {
      toggle.addEventListener('click', function () {
        var on = !root.classList.contains('is-open');
        root.classList.toggle('is-open', on);
        toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (on && emailEl) emailEl.focus();
      });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        days = parseInt(c.getAttribute('data-mvp-remind-in'), 10) || 7;
        chips.forEach(function (x) { x.classList.toggle('is-on', x === c); });
      });
    });

    function say(text, bad) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.classList.toggle('is-bad', !!bad);
      msgEl.hidden = false;
    }

    /* Дата напоминания в YYYY-MM-DD — Klaviyo распознаёт её как дату,
       и сценарий может стартовать именно в этот день. */
    function dueDate() {
      var d = new Date(new Date().getTime() + days * 864e5);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    }
    function niceDate(iso) {
      try { return new Date(iso + 'T12:00:00').toLocaleDateString(document.documentElement.lang || undefined,
        { day: 'numeric', month: 'long' }); } catch (e) { return iso; }
    }

    function props(due) {
      var st = window.DAILE_MVP || {};
      var title = document.querySelector('.daile-pdp__title, h1');
      return {
        reminder_due: due,
        reminder_product: title ? title.textContent.trim() : document.title,
        reminder_url: location.origin + location.pathname,
        reminder_set: st.tier || '',
        reminder_pieces: st.pieces || '',
        reminder_price: st.priceText || '',
        daile_newsletter_opt_in: !!(newsEl && newsEl.checked)
      };
    }

    function klaviyo(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      });
    }

    if (saveEl) {
      saveEl.addEventListener('click', function () {
        var email = (emailEl && emailEl.value || '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) {
          say(root.getAttribute('data-msg-bad'), true);
          if (emailEl) emailEl.focus();
          return;
        }
        if (!company || !listId) { say(root.getAttribute('data-msg-err'), true); return; }

        var due = dueDate();
        var p = props(due);
        saveEl.disabled = true;

        /* Подписка в список напоминаний — согласие на это одно письмо */
        klaviyo('subscriptions', {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'PDP reminder',
              profile: { data: { type: 'profile', attributes: { email: email, properties: p } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        }).then(function (res) {
          if (!res.ok) throw new Error('klaviyo ' + res.status);
          /* событие для метрики и как второй возможный триггер сценария */
          klaviyo('events', {
            data: {
              type: 'event',
              attributes: {
                properties: p,
                metric: { data: { type: 'metric', attributes: { name: 'Requested Reminder' } } },
                profile: { data: { type: 'profile', attributes: { email: email } } }
              }
            }
          }).catch(function () { /* метрика не критична */ });
          root.classList.add('is-done');
          say(root.getAttribute('data-msg-ok') + ' ' + niceDate(due) + '.');
        }).catch(function () {
          saveEl.disabled = false;
          say(root.getAttribute('data-msg-err'), true);
        });
      });
    }
    if (emailEl) {
      emailEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); saveEl.click(); }
      });
    }
  }

  function initAccount() {
    var root = document.querySelector('[data-mvp-acc]');
    if (!root) return;
    var tabs = root.querySelectorAll('[data-mvp-acc-tab]');
    var panes = root.querySelectorAll('[data-mvp-acc-pane]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var key = t.getAttribute('data-mvp-acc-tab');
        tabs.forEach(function (x) { x.classList.toggle('is-on', x === t); });
        panes.forEach(function (p) {
          p.classList.toggle('is-on', p.getAttribute('data-mvp-acc-pane') === key);
        });
      });
    });
    root.querySelectorAll('[data-mvp-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-mvp-copy');
        var done = btn.getAttribute('data-mvp-copied') || 'Copied';
        try { navigator.clipboard.writeText(code); } catch (e) { /* демо */ }
        var orig = btn.textContent;
        btn.textContent = done;
        setTimeout(function () { btn.textContent = orig; }, 1600);
      });
    });
  }

  function init() {
    initFormats();
    initTierGallery();   /* подписка ДО initPdpTiers — первый emit сразу применится */
    initPdpTiers();
    initWhatsInside();
    initStickySync();
    initRemind();
    initAccount();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
